export const dropdownDatePickerChipTestId = 'dropdownDatePickerChipTestId';

export const dropdownDatePickerTexts = {
  DEFAULT_LABEL: 'Select Date Range',
};
